import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchSimilarProducts } from "../../../../Redux/ProductController/action";
import { Link, useParams } from "react-router-dom";
import { Box, Text, Image, Flex } from "@chakra-ui/react";
// import { BsCart2 } from "react-icons/bs";

const SimilarProducts = () => {
  const param = useParams();
  const productId = param._id;
  const dispatch = useDispatch();
  const similarProducts = useSelector(
    (store) => store.prodReducer.similarProducts,
  );

  useEffect(() => {
    dispatch(fetchSimilarProducts(productId));
  }, [dispatch, productId]);

  if (similarProducts && similarProducts?.length === 0) {
    return;
  }

  return (
    <Box textAlign={"left"}>
      <Text
        className="oswald-font"
        color={"#3C375F"}
        fontFamily="Oswald, sans-serif"
        fontSize={{ base: "20", md: "28", lg: "28" }}
        fontWeight={"Bold"}
        textAlign={{ base: "center", md: "left", lg: "left" }}
      >
        Similar Products
      </Text>
      <Text
        textAlign={{ base: "center", md: "left", lg: "left" }}
        fontSize={{ base: "10", md: "20", lg: "20" }}
        color={"#3C375F"}
        fontFamily={"Lato, sans-serif"}
        fontWeight={"normal"}
        mb={{ base: "5", md: "5", lg: "5" }}
      >
        Suggested products you may like
      </Text>
      <Box>
        <Box>
          <Box width="100%" mb={10} textAlign="left" overflowX="auto">
            <Flex
              flexDirection={{ base: "row", md: "row", lg: "row" }}
              gap={"5"}
            >
              {similarProducts &&
                similarProducts?.length !== 0 &&
                similarProducts?.map((product, i) => (
                  <Link key={i} to={`/productDetails/${product.productId}`}>
                    <Box w={"100%"} key={i} position={"relative"}>
                      <Image src={product.img} w={"100%"} h={220} />
                      <Box>
                        <Text
                          color={"#06211A"}
                          letterSpacing={0}
                          fontSize={14}
                          fontWeight={"bold"}
                        >
                          {product.productName}
                        </Text>
                        <Flex
                          gap={10}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          pr={5}
                        >
                          <Box>
                            <Flex gap={1}>
                              <Text
                                color={"#787A79"}
                                fontWeight={"bold"}
                                fontSize={14}
                              >
                                Starting From
                              </Text>

                              <Box
                                fontSize={"16px"}
                                textDecoration={"line-through"}
                              >
                                ₹{product.priceDetails.price}
                              </Box>

                              <Text
                                color={"#395D00"}
                                fontWeight={"bold"}
                                fontSize={17}
                              >
                                ₹{product.priceDetails.sellingPrice}
                              </Text>
                            </Flex>
                          </Box>
                          {/* <Box>
                            <Box
                              bg={"#E5E5E5"}
                              w={8}
                              p={1}
                              pl={"6px"}
                              borderRadius={50}
                            >
                              <BsCart2 size={20} />
                            </Box>
                          </Box> */}
                        </Flex>
                      </Box>
                      {product.isAllVariantSoldOut ? (
                        <Box
                          position="absolute"
                          top="1"
                          left="1"
                          bg="black"
                          px={"7px"}
                          py={"4px"}
                          rounded="sm"
                          fontSize="10px"
                          fontWeight="bold"
                          color={"white"}
                        >
                          SOLD OUT
                        </Box>
                      ) : (
                        <Box
                          position="absolute"
                          top="1"
                          left="1"
                          bg="#1E9C99"
                          px={"13px"}
                          py={"2px"}
                          rounded="md"
                          fontSize="13px"
                          fontWeight="bold"
                          color={"white"}
                        >
                          {`${product.priceDetails.discountPercentage}% Off`}
                        </Box>
                      )}
                    </Box>
                  </Link>
                ))}
            </Flex>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SimilarProducts;
